import axios from 'axios';
import ENDPOINTS from 'constants/endpoints';
import {
    axiosConfigs,
    checkResponseLoggedOut,
    finalizeResponse,
    handleError
} from 'utils/api';

function getItem(itemId) {
    return axios
        .get(ENDPOINTS.GET_ITEM + itemId, { withCredentials: true })
        .then(finalizeResponse())
        .catch(handleError());
}

function postWishlistItem(itemId, add) {
    return axios
        .post(
            add ? ENDPOINTS.WISHLIST_ADD : ENDPOINTS.WISHLIST_REMOVE,
            {
                itemId
            },
            axiosConfigs.authenticated
        )
        .then(checkResponseLoggedOut())
        .then(finalizeResponse())
        .catch(handleError());
}

export { getItem, postWishlistItem };
